import React from 'react';
import { RestaurantAgreement } from '../../components';

const RestaurantAgreementPage = () => {
  return (
    <>
      <RestaurantAgreement />
    </>
  )
}

export default RestaurantAgreementPage;
